// https://api.nylas.com/oauth/authorize?client_id=d3yu5lovbvujuy6vzk7o8zr6i&response_type=token&scopes=calendar&login_hint=matt@onflourish.com&redirect_uri=http://localhost:3000/admin/integrations/calendar&state

import { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom';
import queryString from 'query-string'

import { Button, Chip, CircularProgress, Typography } from "@mui/material";

import { useAppSelector, useAppDispatch } from "../../../hooks";
import { updateNylasCalendarToken, updateNylasAccountID, reloadAuthAccount } from '../../../managers/redux/slices/authAccount';
import { getAvailableCalendars } from '../../../managers/redux/slices/calendar';

export default function CalendarIntegration(props: any) {

    const history = useHistory()
    const dispatch = useAppDispatch()

    const selectedStaffProfile = useAppSelector(state => state.authAccount.selectedStaffProfile)
    const authAccount = useAppSelector(state => state.authAccount.data)
    const cognitoData = useAppSelector(state => state.authAccount.cognitoData)
    const calendar = useAppSelector(state => state.calendar)

    useEffect(() => {
        (async () => {
            if (cognitoData == null) {
                await dispatch(reloadAuthAccount())

                const queryParams = queryString.parse(window.location.search)

                if (queryParams.access_token) {
                    const response = await dispatch(updateNylasCalendarToken({ token: queryParams.access_token }))
                }
                if (queryParams.account_id) {
                    const response = await dispatch(updateNylasAccountID({ id: queryParams.account_id }))
                }
            } else {
                const queryParams = queryString.parse(window.location.search)

                if (queryParams.access_token) {
                    const response = await dispatch(updateNylasCalendarToken({ token: queryParams.access_token }))
                }
                if (queryParams.account_id) {
                    const response = await dispatch(updateNylasAccountID({ id: queryParams.account_id }))
                }
            }
        })()
    }, [])

    useEffect(() => {
        if (selectedStaffProfile && selectedStaffProfile.nylasCalendarToken) {
            dispatch(getAvailableCalendars())
        }
    }, [selectedStaffProfile])

    return (
        <div className="container mt-5">
            <div className="row">
                <div className="col-12 d-flex flex-row justify-content-between align-items-center mb-5">
                    <div className="d-flex flex-row justify-content-center align-items-center">
                        <Typography variant="h2">Calendar</Typography>
                        {
                            selectedStaffProfile && selectedStaffProfile.nylasCalendarToken &&
                            <Chip label="Connected" color="success" className="ms-3" />
                        }
                    </div>
                    <Button variant="outlined" className="px-3" onClick={() => history.push('/admin/integrations')}>Back to Integrations</Button>
                </div>
                {
                    selectedStaffProfile && selectedStaffProfile.nylasCalendarToken ?
                        <div className="col-12">
                            <div className="border rounded p-5 bg-white d-flex flex-row justify-content-between align-items-center">
                                <Typography variant="body1">Your Calendar has been linked to Latent. If you have a question about how this integration works or would like to remove the integration please contact support.</Typography>
                                <Button variant="contained" onClick={() => {
                                    // @ts-ignore
                                    window.Tawk_API.maximize()
                                }}>Contact Support</Button>
                            </div>
                        </div>
                        :
                        <div className="col-12">
                            <div className="border rounded p-5 bg-white d-flex flex-row justify-content-between align-items-center">
                                <Typography variant="body1">Get started using Calendars in Latent by linking your Organization's existing calendars. Click the button to begin the process of authorizing Latent to manage your calendars.</Typography>
                                <a href={`https://api.nylas.com/oauth/authorize?client_id=d3yu5lovbvujuy6vzk7o8zr6i&response_type=token&scopes=calendar&login_hint=${authAccount && authAccount.primaryEmail ? authAccount.primaryEmail : ''}&redirect_uri=${window.location.origin}/admin/calendar&state`} target="_self" style={{ textDecoration: 'none' }}>
                                    <Button variant="contained">Link Calendars</Button>
                                </a>
                            </div>
                        </div>
                }
                {
                    selectedStaffProfile && selectedStaffProfile.nylasCalendarToken ?
                        calendar.availableCalendars ?
                            <div className="row">
                                <Typography variant="h3" className="mt-5 mb-3">Connected Calendars</Typography>
                                {
                                    calendar.availableCalendars.map((calendar: any) => {
                                        return (
                                            <div className="col-12">
                                                <div className="d-flex flex-row justify-content-between align-items-center border rounded bg-white px-5 py-3 mb-3">
                                                    <Typography>{calendar.name}</Typography>
                                                    {
                                                        calendar.is_primary &&
                                                        <Chip label="Primary" color="success" />
                                                    }

                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                            :
                            <div className="col-12 mt-5 d-flex flex-column justify-content-start align-items-center w-100">
                                <CircularProgress />
                                <Typography className="mt-3">Loading available calendars...</Typography>
                            </div>
                        :
                        <div></div>
                }
            </div>
        </div >
    )
}